import { useDispatch } from 'react-redux'

import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useWorkspaces } from './useWorkspaces'
import { workspacesSet } from 'redux/actions'
import { ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'
import { useModals } from 'almanac-ui/Modal'
import { useLoggedIn } from 'hooks/useLoggedIn'
import { useCurrentArticleMeta } from './useCurrentArticleMeta'
import { useFlipperFlag } from './useFlipperFlag'
import { useRouteMatch } from 'react-router-dom'
import { DOC_PATH, FOLDER_DOC_PATH } from 'paths'

export const useEnforceBlazeFreeTrial = () => {
  const workspaces = useWorkspaces()
  const workspace = useCurrentWorkspace()
  const dispatch = useDispatch()
  const { closeModal } = useModals()
  const isLoggedIn = useLoggedIn()
  const articleMeta = useCurrentArticleMeta()
  const isNewRegistration = useFlipperFlag('new_registration')
  const inDoc = useRouteMatch(DOC_PATH)
  const inFolderDoc = useRouteMatch(FOLDER_DOC_PATH)

  const onPaywallUpdateSuccess = (paying: boolean) => {
    const updatedWorkspaces = workspaces.map((ws) => {
      if (ws.id === workspace?.id) {
        return { ...workspace, paying: paying }
      }

      return ws
    })

    closeModal() // Close any modals that may be open (settings, etc.)
    dispatch(workspacesSet(updatedWorkspaces))
  }

  let showPaywall =
    !isNewRegistration &&
    !workspace?.is_virtual_marketer &&
    isLoggedIn &&
    (!(workspace?.paying || workspace?.early_adopter) || workspace?.id === ALMANAC_CORE_WORKSPACE_ID)

  if (inDoc || inFolderDoc) {
    showPaywall = !articleMeta ? false : showPaywall && !articleMeta.main_layer.public
  }

  const canStartFreeTrial = workspace?.subscription_provider !== 'apple' && workspace?.can_start_free_trial

  const hasOtherPayingWorkspaces =
    workspaces.length > 1 && !!workspaces.find((w) => w.id !== ALMANAC_CORE_WORKSPACE_ID && w.paying)

  return { showPaywall, onPaywallUpdateSuccess, hasOtherPayingWorkspaces, canStartFreeTrial }
}
